import { render, staticRenderFns } from "./garden16.vue?vue&type=template&id=167ed44d&scoped=true&"
import script from "./garden16.vue?vue&type=script&lang=js&"
export * from "./garden16.vue?vue&type=script&lang=js&"
import style0 from "./garden16.vue?vue&type=style&index=0&id=167ed44d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ed44d",
  null
  
)

export default component.exports